import {
  BulbOutlined,
  DeleteOutlined,
  FileDoneOutlined,
  LogoutOutlined,
  MoonOutlined,
  PlusOutlined,
  SafetyOutlined,
  SearchOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Avatar, Button, Dropdown, Input, Menu, Switch, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getProfileImage, handleLogout } from "../../Common";
import { ReactComponent as CloudUploadIcon } from "../../assets/svg/cloud-upload-icon.svg";
import LocalLanguage from "../../assets/svg/Locallanguage.svg";

import { deleteUser, getUserProfile } from "../../redux/action/user";
import CustomModal from "../CustomModal";
import UpdateProfile from "./UpdateProfile";
import ResponsiveMenu from "../Aside/ResponsiveMenu";
import { ReactComponent as Hamburger } from "../../assets/svg/hamburger.svg";
import { useLocation } from "react-router-dom";
import { setLoading, setSideBar } from "../../redux/slices/loadingSlice";
import { store } from "../../redux/store";
import { useTheme } from "../../hooks/useTheme";
import { useTranslation } from "react-i18next";
import LanguageDropdown from "./LanguageDropdown";

const Header = ({ isMainHeader = false }) => {
  const location = useLocation();
  const { user, profile_image, storage, packages } = useSelector(
    (state) => state.userSlice
  );
  const [logoutModal, setLogoutModal] = useState(false);
  const [updateProfile, setUpdateProfile] = useState(false);
  const [deleteUserModal, setDeleteUserModal] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);
  const [desktopAction, setDesktopAction] = useState(false);
  const { sideBar } = useSelector((state) => state.loadingSlice);
  const { i18n } = useTranslation();
  const handleDeleteUser = async () => {
    await deleteUser();
    await handleLogout();
    setDeleteUserModal(false);
  };

  useEffect(() => {
    getUserProfile();
    getProfileImage();
  }, []);

  useEffect(() => {
    if (mobileMenu) setMobileMenu(false);
  }, [location?.pathname]);
  const { t } = useTranslation();
  const items = [
    {
      key: "profile",
      label: (
        <span className="font-color" onClick={() => setUpdateProfile(true)}>
          <UserOutlined /> {t("common.update")} {t("common.profile")}
        </span>
      ),
    },
    {
      key: "delete",
      label: (
        <span style={{ color: "red" }} onClick={() => setDeleteUserModal(true)}>
          <DeleteOutlined /> {t("common.delete")} {t("common.user")}
        </span>
      ),
    },
    {
      key: "privacyPolicy",
      label: (
        <a
          className="font-color"
          href="/privacy"
          target="_blank"
        >
          <SafetyOutlined /> {t("common.privacyPolicy")}
        </a>
      ),
    },
    {
      key: "termsOfService",
      label: (
        <a
          className="font-color"
          href="/terms"
          target="_blank"
        >
          <FileDoneOutlined /> {t("common.termsOfService")}
        </a>
      ),
    },
    {
      key: "logout",
      label: (
        <span className="font-color" onClick={() => setLogoutModal(true)}>
          <LogoutOutlined /> {t("common.logout")}
        </span>
      ),
    },
  ];
  const { isDark, toggleTheme } = useTheme("dark");
  return (
    <>
      <header className="main-header">
        <div className="left-side">
          <Hamburger
            className="hamburger"
            onClick={() => {
              if (window.innerWidth <= 968) {
                setMobileMenu(true);
              } else {
                if (sideBar) {
                  store.dispatch(setSideBar(false));
                } else {
                  store.dispatch(setSideBar(true));
                }
              }
            }}
          />
        </div>

        <div className="right-side">
          <div className="header-profile-wrapper">
            {/* Theme Toggle Button */}
            {/* <Tooltip title="Languages">
              <img src={LocalLanguage} />
            </Tooltip> */}
            <LanguageDropdown />
            <Tooltip title="Toggle Theme">
              <Switch
                className="custom-switch-thumb-icon"
                checked={isDark}
                onChange={toggleTheme}
              />
            </Tooltip>

            {/* Profile Avatar + Dropdown */}
            <Dropdown
              menu={{ items, className: "bg-color font-color" }}
              trigger={["click"]}
            >
              <div className="profile-section">
                <Avatar
                  className="avatar"
                  src={profile_image}
                  icon={<UserOutlined />}
                />
                <div className="profile-details">
                  <div className="name">
                    {user?.name}{" "}
                    <span className="plan">{packages[0]?.packageName}</span>
                  </div>
                  <div className="email">{user?.email}</div>
                </div>
              </div>
            </Dropdown>
          </div>
        </div>
      </header>
      {logoutModal && (
        <CustomModal
          title={<span className="font-color">{t("common.logout")}</span>}
          visible={logoutModal}
          className="my-custom-modal"
          handleCancel={() => setLogoutModal(false)}
          width={400}
          footer={false}
        >
          <span className="font-color">{t("messages.confirmLogout")}</span>
          <div className="figma-modal-footer">
            <Button
              onClick={() => setLogoutModal(false)}
              className="figma-cancel-btn"
            >
              {t("common.cancel")}
            </Button>

            <Button
              type="primary"
              onClick={handleLogout}
              className="figma-delete-btn"
            >
              {t("common.logout")}
            </Button>
          </div>
        </CustomModal>
      )}
      {updateProfile && (
        <UpdateProfile
          updateProfile={updateProfile}
          setUpdateProfile={setUpdateProfile}
        />
      )}
      {deleteUserModal && (
        <CustomModal
          title={
            <span>
              {t("common.delete")} {t("common.user")}
            </span>
          }
          visible={deleteUserModal}
          className="my-custom-modal"
          handleCancel={() => setDeleteUserModal(false)}
          // handleOk={handleDeleteUser}
          width={400}
          footer={false}
        >
          <span className="font-color">
            {t("messages.confirmDeleteAccount")}
          </span>
          <div className="figma-modal-footer">
            <Button
              onClick={() => setDeleteUserModal(false)}
              className="figma-cancel-btn"
            >
              {t("common.cancel")}
            </Button>

            <Button
              type="primary"
              onClick={handleDeleteUser}
              className="figma-delete-btn"
            >
              {t("common.delete")}
            </Button>
          </div>
        </CustomModal>
      )}

      <ResponsiveMenu open={mobileMenu} setOpen={setMobileMenu} />
    </>
  );
};

export default Header;
